export default __webpack_public_path__ + "static/media/looking_at_catalog.79e86cd3.svg";